import buildRoute from './buildRoute'

export const addDevice = async (formData: any) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'device',
            data: formData,
        })
        if (res.data) {
            return res
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}

export const addMultipleDevices = async (formData: any) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'multiple-devices',
            data: formData,
        })

        if (res?.data) {
            return res
        }
    } catch (err: any) {
        console.error('Error uploading file:', err)
        return err
    }
}

export const getDevices = async (active) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'devices',
            data: { active },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        return console.error(err)
    }
}

interface SelectionType {
    data: []
    activate: boolean
}

export const deactivateDevices = async (selection: SelectionType) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'device-activations',
            data: selection,
        })
        if (res.data) {
            return res
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}

interface SelectionType {
    data: []
    activate: boolean
}

export const deleteDevice = async (selection: SelectionType) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'device-deletion',
            data: selection,
        })
        if (res.data) {
            return res
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}
interface GetDeviceQueryProps {
    active: boolean
    limit?: number
    search?: any
    manufacturer?: any
}
export const getDeviceQuery = async ({
    active,
    search = '',
    limit = 20,
    manufacturer,
}: GetDeviceQueryProps) => {
    try {
        const res: any = await buildRoute({
            type: 'post',
            route: 'device-query',
            data: { active, limit, search, manufacturer },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        console.error(err)
        throw err
    }
}

interface GetDevicesProps {
    active: boolean
    page?: number
    limit?: number
    filter?: any
}

export const getDevicesWithLimiter = async ({
    active,
    page = 1,
    limit = 50,
    filter,
}: GetDevicesProps) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'devices-With-Limiter',
            data: { active, page, limit, filter },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        return console.error(err)
    }
}

const deviceRoutes = {
    getDevices,
    deactivateDevices,
    addDevice,
    deleteDevice,
    addMultipleDevices,
    getDeviceQuery,
    getDevicesWithLimiter,
}

export default deviceRoutes
